import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/org/$org/')({
  beforeLoad: ({ params }) => {
    throw redirect({ to: '/org/$org', params: { org: params.org } })
  },
})
